import { render } from "./Progressbar.vue?vue&type=template&id=b33d18e2&scoped=true&ts=true"
import script from "./Progressbar.vue?vue&type=script&lang=ts"
export * from "./Progressbar.vue?vue&type=script&lang=ts"

import "./progressbar.scss?vue&type=style&index=0&id=b33d18e2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33d18e2"]])

export default __exports__